
export const services = [
  {
    id: 1,
    title: 'Bakkie Removals',
    description: 'Affordable small bakkie removals with trailers for homes, flats, and offices across KZN',
    image: 'https://public.readdy.ai/ai/img_res/525727d4642c2b92ae5a53c58c3e0dab.jpg',
    link: '/removals',
  },
  {
    id: 2,
    title: 'Furniture Transport',
    description: 'Safe and secure furniture transport with careful handling and insured vehicles',
    image: 'https://readdy.ai/api/search-image?query=professional%20movers%20carefully%20loading%20furniture%20sofa%20and%20chairs%20onto%20green%20bakkie%20truck%20in%20south%20african%20residential%20area%20clean%20simple%20background%20bright%20daylight&width=400&height=300&seq=service2&orientation=landscape',
    link: '/removals',
  },
  {
    id: 3,
    title: 'Long-Distance Moves',
    description: 'Reliable long-distance removals throughout KwaZulu-Natal, urban and rural areas',
    image: 'https://readdy.ai/api/search-image?query=green%20bakkie%20truck%20driving%20on%20south%20african%20highway%20with%20kwazulu%20natal%20landscape%20hills%20in%20background%20clean%20simple%20background%20bright%20daylight%20professional%20transport&width=400&height=300&seq=service3&orientation=landscape',
    link: '/removals',
  },
  {
    id: 4,
    title: 'Landscaping Services',
    description: 'Professional garden design, landscaping, and outdoor space transformation',
    image: 'https://readdy.ai/api/search-image?query=professional%20landscaper%20working%20on%20beautiful%20south%20african%20garden%20with%20green%20plants%20flowers%20and%20lawn%20clean%20simple%20background%20bright%20daylight%20residential%20setting&width=400&height=300&seq=service4&orientation=landscape',
    link: '/landscaping-services',
  },
  {
    id: 5,
    title: 'Garden Clean-Ups',
    description: 'Complete garden maintenance, clean-ups, and waste removal services',
    image: 'https://readdy.ai/api/search-image?query=professional%20garden%20maintenance%20team%20cleaning%20up%20garden%20with%20tools%20and%20green%20waste%20bags%20in%20south%20african%20residential%20yard%20clean%20simple%20background%20bright%20daylight&width=400&height=300&seq=service5&orientation=landscape',
    link: '/landscaping-services',
  },
  {
    id: 6,
    title: 'Compost Delivery',
    description: 'Quality compost supply and delivery for gardens across Durban and KZN',
    image: 'https://readdy.ai/api/search-image?query=bags%20of%20quality%20compost%20and%20soil%20being%20delivered%20by%20green%20bakkie%20truck%20in%20south%20african%20garden%20setting%20clean%20simple%20background%20bright%20daylight%20professional%20service&width=400&height=300&seq=service6&orientation=landscape',
    link: '/landscaping-services',
  },
];
